{
  "pt": {
    "company": {
      "actions": {
        "changeCompany": "Mudar de organização",
        "searchCompany": "Pesquisar organização"
      },
      "attributes": {
        "address": "Endereço",
        "email_address": "E-mail",
        "iban": "IBAN",
        "language": "Língua",
        "name": "Nome da organização",
        "phone": "Telefone",
        "subdomain": "Subdomínio",
        "vat": "IVA"
      },
      "labels": {
        "company": "Organização",
        "contact": "Contacto",
        "contacts": "Contactos",
        "language": "Esta é a língua predefinida da organização para a sua página de início de sessão, clientes e membros da equipa.",
        "or": "OU"
      },
      "validation": {
        "contactAlreadyExist": "O contacto já existe. Selecione a partir do menu pendente.",
        "mustBeEmailAddress": "É necessário um endereço de e-mail válido",
        "needName": "O nome é obrigatório"
      }
    }
  }
}
